export default function selectAllOptions({ state, input }) {
  let filteredOptions = state.get(`${input.field}.filteredOptions`)
  if (filteredOptions) {
    filteredOptions = filteredOptions.map(option => {
      const { key, value } = option
      return {
        key,
        value,
        selected: true
      }
    })
    state.set(`${input.field}.filteredOptions`, filteredOptions)
  }

  let options = state.get(`${input.field}.options`)
  options = options.map((option, index) => {
    return {
      ...option,
      index: index,
      selected: true
    }
  })
  state.merge(input.field, { options: options, value: options })
}



// WEBPACK FOOTER //
// ./src/modules/client/actions/selectAllOptions.js